/**
 * Rodapé fixo do sidebar/drawer: user badge, trocar senha, toggle de tema, e logout.
 */
import { useState } from "react";
import { Sun, Moon, SignOut, Key } from "@phosphor-icons/react";
import ChangePasswordDialog from "@/components/ChangePasswordDialog";

export default function SidebarFooter({ user, theme, onToggleTheme, onLogout, showLabels }) {
  const [showPwd, setShowPwd] = useState(false);
  return (
    <div className="border-t border-black shrink-0" data-testid="sidebar-footer">
      {showLabels && (
        <div className="px-4 py-2 text-[10px] text-zinc-500 leading-tight">
          <div className="overline text-[9px]">Logado como</div>
          <div className="font-mono mt-0.5 text-black text-xs truncate" data-testid="current-user-name">
            {user?.name || "—"}
          </div>
        </div>
      )}
      <button
        onClick={() => setShowPwd(true)}
        data-testid="change-password-button"
        className={`!border-t !border-black/10 ${!showLabels ? "!justify-center !px-2" : ""}`}
        title="Trocar minha senha"
      >
        <Key size={showLabels ? 18 : 20} weight="bold" />
        {showLabels && <span>Trocar Senha</span>}
      </button>
      <button
        onClick={onToggleTheme}
        data-testid="theme-toggle"
        className={`!border-t !border-black/10 ${!showLabels ? "!justify-center !px-2" : ""}`}
        title={theme === "dark" ? "Alternar para claro" : "Alternar para escuro"}
      >
        {theme === "dark" ? <Sun size={showLabels ? 18 : 20} weight="bold" /> : <Moon size={showLabels ? 18 : 20} weight="bold" />}
        {showLabels && <span>{theme === "dark" ? "Modo Claro" : "Modo Escuro"}</span>}
      </button>
      <button
        onClick={onLogout}
        data-testid="logout-button"
        className={`hover:bg-red-50 hover:text-red-700 ${!showLabels ? "!justify-center !px-2" : ""}`}
        title="Sair"
      >
        <SignOut size={showLabels ? 18 : 20} weight="bold" />
        {showLabels && <span>Sair</span>}
      </button>
      {showPwd && <ChangePasswordDialog onClose={() => setShowPwd(false)} />}
    </div>
  );
}
